import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import OTPInput from "react-otp-input";

import './styles.scss';
import OTPIcon from "../../../assets/images/OTP-verification-icon.svg";
import SpinLoader from "../../../assets/component/loader/loader";

const OTPCard = ({ otp, setOtp, showOtpScreen, email, handleOtpChange, loading }) => {

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleOtpChange()
        }
        if (e.key === "Backspace" && otp.length > 0) {
            setOtp(otp.slice(0, -1));
        }
    };

    return (
        <div className="otp-card">
            <div className="close-screen-button">
                <FontAwesomeIcon className="close-icon" icon={faXmark} onClick={() => showOtpScreen(false)} />
            </div>
            <div className="verification-icon">
                <img src={OTPIcon} className="otp-icon" alt="OTP Icon" />
            </div>
            <div className="screen-title">
                <h1>Verification Code</h1>
                <p>We've sent a verification code to {email}</p>
            </div>
            <div className="otp-inputs-container">
                {loading ? (<SpinLoader />) : (
                    <OTPInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={4}
                        renderSeparator={<span>-</span>}
                        renderInput={(props) => <input className="otp-input" type="number" {...props} onKeyDown={handleKeyDown} />}
                        containerStyle={{ gap: "5px" }}
                        shouldAutoFocus
                    />
                )}

            </div>
            <div className="otp-validation-buton" onClick={handleOtpChange}>Validate</div>
            {/* <div className={`resend-text ${resendOtp ? "resend" : ""}`} onClick={handleResendOTP}>
                {!resendOtp ? "Resend OTP" : "OTP Sent"}
            </div> */}
        </div >
    );
};

export default OTPCard;
